import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CommonTable from "../../common-components/common-tables/CommonTable";
import { fetchTMEGymwiseAnalysisData } from "../../../redux/prospect-reducers/prospectSlice";
import { ReloadIcon } from "../../../images/icons/icons";
import useTableSorting from "../../../hooks/useTableSorting";
import SortableHeader from "../../common-components/SortableHeader";

const TMEGymwiseAnalysis = ({ userInfoData, allFilters, setModValues }) => {
  const dispatch = useDispatch();
  const {
    tmeGymwiseAnalysis,
    tmeGymwiseAnalysisError,
    tmeGymwiseAnalysisLoading,
  } = useSelector((state) => state.prospects);

  const iniDatas = {
    pagination: [],
    tbData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(30);

  const { handleSort, getSortDirection, isFieldSorted, sortedData } =
    useTableSorting(allDatas.tbData || []);
  const iniFilters = {
    limit: pageLimit,
    page: isPage + 1,
    gym_id: allFilters.selectedGym?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const getGymwiseData = (filters) => {
    dispatch(
      fetchTMEGymwiseAnalysisData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getGymwiseData(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      limit: pageLimit,
      page: isPage + 1,
      gym_id: allFilters.selectedGym?.value || "",
    }));
  }, [isPage, pageLimit, allFilters.selectedGym]);

  useEffect(() => {
    if (
      !tmeGymwiseAnalysisLoading &&
      !tmeGymwiseAnalysisError &&
      tmeGymwiseAnalysis?.status &&
      tmeGymwiseAnalysis?.data
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        tbData: tmeGymwiseAnalysis.data,
        pagination: tmeGymwiseAnalysis?.pagination || [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [tmeGymwiseAnalysisLoading, tmeGymwiseAnalysisError, tmeGymwiseAnalysis]);

  const tbColumns = [
    {
      dataField: "gym_id",
      text: "Gym Name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 30;

        return (
          <span
            className={`tb-data tb-link ${isLong ? "tb-data-long" : ""}`}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "tme-gym-analysis-details",
                rowData: row,
              }))
            }
          >
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "all_trainers",
      text: (
        <SortableHeader
          text="Trainer"
          field="all_trainers"
          onSort={handleSort}
          sortDirection={getSortDirection("all_trainers")}
          isSorted={isFieldSorted("all_trainers")}
        />
      ),
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-badge tb-badge-success-1">
            {row?.all_trainers || 0} trainers
          </span>
        );
      },
    },
    {
      dataField: "active_members",
      text: (
        <SortableHeader
          text="Members"
          field="active_members"
          onSort={handleSort}
          sortDirection={getSortDirection("active_members")}
          isSorted={isFieldSorted("active_members")}
        />
      ),
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-badge tb-badge-success-2">
            {row?.active_members || 0} members
          </span>
        );
      },
    },
  ];

  return (
    <div className="flex-col-tables-container">
      <div className="tme-tb-header">
        <h3 className="tm-tb-header-title">
          All Gyms ({tmeGymwiseAnalysis?.pagination?.[0]?.pagination || 0}){" "}
          <button
            className="page-heading-reload-btn"
            onClick={() => getGymwiseData(filters)}
            title="Reload"
            type="button"
          >
            <ReloadIcon />
          </button>
        </h3>

        <div className="common-table-container tb-bordered">
          <CommonTable
            tableData={sortedData}
            tablePagination={allDatas.pagination}
            tableColumns={tbColumns}
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            isLoading={tmeGymwiseAnalysisLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default TMEGymwiseAnalysis;
